import { Component, ElementRef, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';
import { IframeService } from './services/iframe.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
  title = 'saruman';
  constructor(private _elementRef: ElementRef, private iframeService: IframeService) {}

  ngOnInit(): void {
    this._elementRef.nativeElement.removeAttribute('ng-version');

    const script = document.createElement('script');

    // TODO: remove this check when Cloudflare cache is fixed
    let version = localStorage.getItem('sdk_version');

    if (!version) {
      version = '0';
      localStorage.setItem('sdk_version', version);
    }

    script.type = 'text/javascript';
    script.src = environment.payvalidaJsSdk + '?v=' + version;
    script.defer = true;

    document.body.appendChild(script);

    this.initIframeSettings();
  }

  async initIframeSettings() {
    this.iframeService.getIsIframe();
    this.iframeService.getAutoExposeTcFormFeatureFlag();
  }
}
